export const ALERT_DIALOG_TYPE_DOWNLOAD = 'download';
export const ALERT_DIALOG_TYPE_INFO = 'info';
export const ALERT_DIALOG_TYPE_ACTIVATE = 'activate';
